module.exports = __webpack_public_path__ + "static/media/special.cff0d86a.pdf";